module.exports = __webpack_public_path__ + "assets/img/052d-ne.svg";